module.exports = __webpack_public_path__ + "static/media/27.1ef35d7d.mp3";